import { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningCircleIcon } from "@progress/kendo-svg-icons";

export default function NoRequirementPage(): ReactElement {
  const localizationService = useLocalization();


  return (
    <div className="gb-text-normal  text-lg text-center"
        style={{ borderRadius: '3px', padding: '40px 25px',margin: '30px auto'}}>
        <div className="text-center mb-5">
          <SvgIcon icon={warningCircleIcon} style={{fontSize:'72px'}} size="xxxlarge"/>
        </div>
        <div>
        
            <div>{localizationService.toLanguageString('custom.noRequirementAssigned', enMessages.custom.noRequirementAssigned)}</div>
            <br></br>
            <div>{localizationService.toLanguageString('custom.pleaseAssignRequirement', enMessages.custom.pleaseAssignRequirement)}</div>
        </div>
    </div> 
  )}
